import React from "react";
import NavBar from "../../components/navBar/NavBar";

import "../../assets/style/style.css";
import axios from "axios";

import Look from "../../components/look/look";
import { Link } from "react-router-dom";
const url = process.env.REACT_APP_API_TASK;

class TaskHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tasksArray : []
    };
  }

  componentDidMount = () => {
   
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  onChangeState = event => {
    let input = event.target.name ;
    this.setState({
      [event.target.name]: event.target.value
    },() => {
     
      
      if(input === "buscar"){
        this.getViabilidades(this.state.buscar);
      }
      
     
    } );

    
  };

  getViabilidades = value => {

    if (value.length === 0) {
      this.setState({
        tasksArray: []
      });
    }

    if (value && value.length % 3 === 0) {
      const objForm = {
        token: localStorage.getItem("token"),
        search: value
      };
      axios
        .post(
          `${url}/getViabilidadesAllApp`,
          {
            objForm: objForm
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          console.log(response);

          this.setState({
            tasksArray: response.data.tasks
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  };

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast="/task" />
        <div className="container-fluid container_body">
          <div className="containerCard">
            <div className="card marginTop6">
              <h5 className="card-header">Histórico de Tarefa</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="id">Buscar Empresa</label>
                  <input
                    type="text"
                    className="form-control"
                    id="id"
                    defaultValue=""
                    name="buscar"
                    placeholder="Digite a Empresa ou ID"
                    onChange={this.onChangeState.bind()}
                  />
                </div>
              </div>
             
              <div className="col-12 d-flex justify-content-center mt-3">
                <table className="table">
                  <thead>
                    <tr className="colorTitleTable">
                      <th scope="col">ID</th>
                      <th scope="col">Empresa</th>
                      <th scope="col" />
                    </tr>
                    </thead>
                    <tbody>
                  
                    {
                      this.state.tasksArray.map(value => (
                        <React.Fragment key={value.id}>
                        <tr>
                          <td>{value.id}</td>
                          <td>{value.empresa}</td>  
                          <td>
                            <Link to={`activity-client-history/${value.id}`}>
                              <Look/>
                            </Link>
                          </td>  
                        </tr>
                        </React.Fragment>
                      ))
                    }
                      
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TaskHistory;
